// --tyrian-purple: #681244ff;
// --claret: #860E33ff;

export const redHandedStyles = {
  image: {
    titleTransparent: process.env.REACT_APP_HEADER_IMAGE,
    title: process.env.REACT_APP_HEADER_IMAGE,
    donateCTA: 'blue-skies-donate-cta.png',
  },
  font: {
    heading: 'Cheddar Gothic Sans',
    subheading: 'Glacial Indifference',
    paragraph: 'PT Sans, sans-serif',
    subheadingWeight: 'bold',
    subheadingTransform: 'uppercase',
  },
  strings: {
    title: 'Great American Debate',
  },
  color: {
    text: '#681244ff',
    textLight: '#860E33ff',
    background: '#fff',
    shadow: '#bbb',
  },
  layout: {
    background: '#f3f3f3',
  },
}
